export default __webpack_public_path__ + "static/media/instagram_colored.37927c3a.png";